// Curated stock imagery (Unsplash) — leaning toward realistic working-class
// American renovation/construction work, not glossy architectural magazine shots.
// Better aligned with Bevel's Tulsa/Owasso clientele.

export const STOCK = {
    // Real Estate Partner — classic American suburban home (relatable, sellable)
    realEstateHero:
        "/stock/unsplash-1568605114967.jpg",
    // Commercial Projects — real working commercial build site
    commercialHero:
        "/stock/unsplash-1503387762.jpg",
    commercialSecondary:
        "/stock/unsplash-1581094271901.jpg",
    // Residential Renovations — actual renovation in progress, not staged
    residentialHero:
        "/stock/unsplash-1581858726788.jpg",
    residentialSecondary:
        "/stock/unsplash-1517581177682.jpg",
    // About — working construction hands on site
    aboutHero:
        "/stock/unsplash-1504307651254.jpg",
    // Contact — calmer, planning desk/architectural
    contactHero:
        "/stock/unsplash-1497366754035-2400.jpg",
    // Optional accents
    accent1:
        "/stock/unsplash-1541123437800.jpg",
};

// Gallery imagery used to fill the Commercial / Residential portfolio
// sections until the admin uploads real project photos.
export const COMMERCIAL_GALLERY = [
    {
        src: "/stock/unsplash-1497366216548.jpg",
        title: "Modern Office Buildout",
    },
    {
        src: "/stock/unsplash-1497366811353.jpg",
        title: "Conference & Meeting Suites",
    },
    {
        src: "/stock/unsplash-1556761175.jpg",
        title: "Open Plan Workspace",
    },
    {
        src: "/stock/unsplash-1604328698692.jpg",
        title: "Retail Build-Out",
    },
    {
        src: "/stock/unsplash-1486325212027.jpg",
        title: "Mixed-Use Commercial",
    },
    {
        src: "/stock/unsplash-1497366754035-1200.jpg",
        title: "Corporate Interior",
    },
];

export const RESIDENTIAL_GALLERY = [
    {
        src: "/stock/unsplash-1565538810643.jpg",
        title: "Modern Kitchen Remodel",
    },
    {
        src: "/stock/unsplash-1552321554.jpg",
        title: "Bathroom Refresh",
    },
    {
        src: "/stock/unsplash-1586023492125.jpg",
        title: "Living Room Renovation",
    },
    {
        src: "/stock/unsplash-1570129477492.jpg",
        title: "Whole Home Refresh",
    },
    {
        src: "/stock/unsplash-1540518614846.jpg",
        title: "Primary Suite",
    },
    {
        src: "/stock/unsplash-1600210492493.jpg",
        title: "Open Concept Reno",
    },
];
